import { Produkt } from "~app/common/models/produkt/ProduktSearchResponseDTO";

export class ProduktSearchResultViewModel {
    constructor(private readonly model: Produkt) {
    }

    get id() {
        return this.model.id;
    }

    get namn() {
        return this.model.namn;
    }

    get beteckning() {
        return this.model.beteckning;
    }

    get produktgrupp() {
        return this.model.produktgrupp.namn;
    }

    get handelssortimentskategori() {
        return this.model.handelssortimentskategori;
    }

    get handelssortiment() {
        return this.model.handelssortimentCollection.map(x => x.namn).join(", ");
    }

    get handelssortimentList() {
        return this.model.handelssortimentCollection;
    }

    get tradslag() {
        return this.model.tradslagCollection.map(x => x.namn).join(", ");
    }

    get sortiment() {
        return this.model.sortimentCollection.map(x => x.kod).join(", ");
    }

    get aktiv() {
        return this.model.aktiv;
    }
}
